import React, { useContext, useEffect, useRef, useState } from "react";
import * as atlas from "azure-maps-control";
import { useSelector } from "react-redux";
import RegionDataBar from "../regiondatabar/regiondatabar";
import Touchpoints from "../filters/touchpoints";
import Recommendations from "../filters/recommendations";
import ExternalData from "../filters/externaldata";
import { FiltersContext } from "../../context/filterscontext";
import QuickIntro from "../regiondatabar/quickintro";
import IQOSsidebar from "../regiondatabar/shellsidebar";
import { SidebarContext } from "../../context/sidebarcontext";
import { MapviewContext } from "../../context/mapviewcontext";
import { ApiContext } from "../../context/apicontext";
import html2canvas from "html2canvas";

// Azure key
const AZURE_MAPS_KEY = "Bv2qUdOfY8nxfdgImdm6xXWVakZNSht1Lecqp8Jrf46gNmWsf1E6JQQJ99BCAC5RqLJdgHQZAAAgAZMP2JhD";

export function MapConfig() {
  const mapRef = useRef(null);
  const center = useSelector((state) => state.map.center);
  const zoom = useSelector((state) => state.map.zoom);
  const { showFilters, setIsOpenDatabar, isOpenDatabar } = useContext(FiltersContext);
  const { locationData, regionData, } = useContext(ApiContext);
  const { setSelectedPlace, selectedRegion, selectedPlace, setStorePlaceHistory, selectedTerritory, setSelectedTerritory, selectedInnerTerritory, setSelectedInnerTerritory, setSearchBarData } = useContext(MapviewContext);
  const map = useRef(null);
  const dataSourceRef = useRef(null);
  const isOpenDatabarRef = useRef(false);
  const selectedPlaceRef = useRef('');
  const [leafletLocationData, setLeafletLocationData] = useState([]);
  const leafletRegionData = useRef([])
  const leafletTerritoryData = useRef([])
  const [loadTerritoryMap, setLoadTerritoryMap] = useState();
  const { setBreadcrumbData, breadcrumbData, selectedIndicator } = useContext(SidebarContext);

  const addresses = [
    "Masarykova 37, 602 00 Brno, Czech Republic",
    "Náměstí Svobody 17, 602 00 Brno, Czech Republic",
    "Veveří 46, 602 00 Brno, Czech Republic",
    "Husova 10, 602 00 Brno, Czech Republic",
    "Joštova 10, 602 00 Brno, Czech Republic",
    "Benešova 18, 602 00 Brno, Czech Republic",
    "Lidická 50, 602 00 Brno, Czech Republic",
    "Nové sady 25, 602 00 Brno, Czech Republic",
    "Kounicova 65, 602 00 Brno, Czech Republic",
    "Hybešova 30, 602 00 Brno, Czech Republic",
    "Pekařská 84, 602 00 Brno, Czech Republic",
    "Cejl 32, 602 00 Brno, Czech Republic",
    "Dornych 48, 602 00 Brno, Czech Republic",
    "Kotlářská 65, 602 00 Brno, Czech Republic",
    "Francouzská 102, 602 00 Brno, Czech Republic",
    "Minská 85, 616 00 Brno, Czech Republic",
    "Zborovská 49, 616 00 Brno, Czech Republic",
    "Úvoz 125, 602 00 Brno, Czech Republic",
    "Táborská 57, 615 00 Brno, Czech Republic",
    "Hlinky 40, 603 00 Brno, Czech Republic",
    "Údolní 41, 602 00 Brno, Czech Republic",
    "Křížkovského 55, 603 00 Brno, Czech Republic",
    "Vídeňská 121, 619 00 Brno, Czech Republic",
    "Heršpická 101, 619 00 Brno, Czech Republic",
    "Kopečná 35, 602 00 Brno, Czech Republic",
    "Trnitá 5, 602 00 Brno, Czech Republic",
    "Křenová 89, 602 00 Brno, Czech Republic",
    "Pálavské náměstí 5, 628 00 Brno, Czech Republic",
    "Šumavská 35, 602 00 Brno, Czech Republic",
    "Botanická 3, 602 00 Brno, Czech Republic",
    "Bohunická 77, 619 00 Brno, Czech Republic",
    "Slovákova 17, 602 00 Brno, Czech Republic",
    "Havlíčkova 28, 602 00 Brno, Czech Republic",
    "Jaselská 18, 602 00 Brno, Czech Republic",
    "Tuřanka 45, 627 00 Brno, Czech Republic",
    "Jihlavská 92, 625 00 Brno, Czech Republic",
    "Veslařská 201, 637 00 Brno, Czech Republic",
    "Holandská 10, 639 00 Brno, Czech Republic",
    "Lány 30, 625 00 Brno, Czech Republic",
    "Kníničská 15, 635 00 Brno, Czech Republic",
    "Purkyňova 107, 612 00 Brno, Czech Republic",
    "Vlhká 17, 602 00 Brno, Czech Republic",
    "Tylova 34, 602 00 Brno, Czech Republic",
    "Bratislavská 31, 602 00 Brno, Czech Republic",
    "Poděbradova 49, 612 00 Brno, Czech Republic",
    "Moravské náměstí 12, 602 00 Brno, Czech Republic",
    "Smetanova 14, 602 00 Brno, Czech Republic",
    "Jamborova 35, 615 00 Brno, Czech Republic",
    "Tkalcovská 31, 602 00 Brno, Czech Republic",
    "Havraní 2, 602 00 Brno, Czech Republic",
    "Husovická 24, 614 00 Brno, Czech Republic",
    "Bělohorská 67, 636 00 Brno, Czech Republic",
    "Jana Uhra 12, 602 00 Brno, Czech Republic",
    "Křídlovická 68, 602 00 Brno, Czech Republic",
    "Skácelova 22, 616 00 Brno, Czech Republic",
    "Oblá 53, 634 00 Brno, Czech Republic",
    "Hlinky 68, 603 00 Brno, Czech Republic",
    "Vychodilova 22, 621 00 Brno, Czech Republic",
    "Tyršova 14, 664 00 Brno, Czech Republic",
    "Bakalovo nábřeží 8, 602 00 Brno, Czech Republic",
    "Edisonova 41, 612 00 Brno, Czech Republic",
    "Trýbova 9, 602 00 Brno, Czech Republic",
    "Vážného 15, 621 00 Brno, Czech Republic",
    "Hvozdecká 3, 635 00 Brno, Czech Republic",
    "Kovárenská 2, 602 00 Brno, Czech Republic",
    "Stránského 6, 616 00 Brno, Czech Republic",
    "Zlatníky 18, 602 00 Brno, Czech Republic",
    "U Leskavy 36, 625 00 Brno, Czech Republic",
    "Svitavská 15, 614 00 Brno, Czech Republic",
    "Šilingrovo náměstí 3, 602 00 Brno, Czech Republic",
    "Černopolní 45, 613 00 Brno, Czech Republic",
    "Příkop 8, 602 00 Brno, Czech Republic",
    "Veslařská 97, 637 00 Brno, Czech Republic",
    "Lipová 16, 602 00 Brno, Czech Republic",
    "Novoměstská 61, 621 00 Brno, Czech Republic",
    "Jana Babáka 1, 602 00 Brno, Czech Republic",
    "Mikuláškovo náměstí 10, 625 00 Brno, Czech Republic",
    "Mezníkova 12, 616 00 Brno, Czech Republic",
    "Nopova 16, 618 00 Brno, Czech Republic",
    "Lány 50, 625 00 Brno, Czech Republic",
    "Václavská 16, 603 00 Brno, Czech Republic"
  ];

  useEffect(() => {

    if (map.current) {
      map.current.dispose();
      map.current = null;
    }
    if (!showFilters) {
      if (!selectedRegion) {
        if (!mapRef.current) return;

        map.current = new atlas.Map(mapRef.current, {
          center: [16.0730, 49.6175],
          zoom: [6.5],
          showLogo: false,
          style: "grayscale_light",
          showFeedbackLink: false,
          enableAccessibility: false,
          disableTelemetry: true,
          textAllowOverlap: false,
          authOptions: {
            authType: atlas.AuthenticationType.subscriptionKey,
            subscriptionKey: AZURE_MAPS_KEY,
          },

          // To disable the map zoom in zoom out
          zoomInteraction: false,
          dblClickZoomInteraction: false,
          dragRotateInteraction: false,
          // interactive: false,
          scrollZoomInteraction: false,
          keyboardInteraction: false
        });

        if (leafletLocationData.length <= 0) {
          setLeafletLocationData(locationData);
          setSearchBarData(locationData);
          map.current.events.add("ready", () => {
            if (dataSourceRef.current) {
              dataSourceRef.current.clear();
            }

            var dataSource = new atlas.source.DataSource();
            dataSourceRef.current = dataSource;
            map.current.sources.add(dataSource);

            locationData.forEach((location) => {
              const polygonFeature = new atlas.data.Feature(
                new atlas.data.Polygon([location.coordinates]),
                { name: location.name, value: location.value, color: location.color }
              );

              dataSource.add(new atlas.Shape(polygonFeature));
            });

            var polygonLayer = new atlas.layer.PolygonLayer(dataSource, 'myPolygonLayer', {
              fillColor: ["get", "color"],
              fillOpacity: 0.8
            });

            var lineLayer = new atlas.layer.LineLayer(dataSource, 'myLineLayer', {
              strokeColor: '#001B48',
              strokeWidth: 1
            });

            var hoverLineLayer = new atlas.layer.LineLayer(dataSource, 'hoverLineLayer', {
              strokeColor: '#001B48',
              strokeWidth: 3,
              filter: ['==', ['get', 'name'], ""]
            });

            var textLayer = new atlas.layer.SymbolLayer(dataSource, null, {
              iconOptions: { opacity: 0 },
              textOptions: {
                textField: ["concat", ["get", "name"], " - ", ["get", "value"]],
                size: 18,
                fontFamily: ["Lato"],
                offset: [0, 0],
                allowOverlap: false,
                ignorePlacement: false,
                textAllowOverlap: false
              },
              filter: [
                "all",
                ["!", ["has", "cluster"]],
                [">=", ["zoom"], 5]
              ],
            })

            map.current.layers.add([polygonLayer, lineLayer, hoverLineLayer, textLayer])

            map.current.events.add("click", polygonLayer, (event) => {
              if (event.shapes.length > 0) {
                if (!!event.shapes[0].data.properties.name) {
                  setIsOpenDatabar(true);
                  isOpenDatabarRef.current = true;
                  selectedPlaceRef.current = event.shapes[0].data.properties.name;
                  hoverLineLayer.setOptions({ filter: ['==', ['get', 'name'], selectedPlaceRef.current] })
                  handleSelectPlace(selectedPlaceRef.current);
                  setBreadcrumbData(selectedPlaceRef.current);
                }
              } else {
                isOpenDatabarRef.current = false;
                setIsOpenDatabar(false);
              }
            });

            map.current.events.add('mousemove', polygonLayer, (event) => {
              if (!!isOpenDatabarRef.current) {
                hoverLineLayer.setOptions({ filter: ['==', ['get', 'name'], selectedPlaceRef.current] })
              } else {
                if (!!event.shapes[0].data.properties.name) {
                  hoverLineLayer.setOptions({ filter: ['==', ['get', 'name'], event.shapes[0].data.properties.name] })
                } else {
                  hoverLineLayer.setOptions({ filter: ['==', ['get', 'name'], ''] })
                }
              }
            });
          });
        }
      } else {
        if (!mapRef.current) return;

        map.current = new atlas.Map(mapRef.current, {
          center: leafletRegionData.current.center,
          zoom: leafletRegionData.current.zoom,
          showLogo: false,
          style: "grayscale_light",
          showFeedbackLink: false,
          enableAccessibility: false,
          disableTelemetry: true,
          textAllowOverlap: false,
          authOptions: {
            authType: atlas.AuthenticationType.subscriptionKey,
            subscriptionKey: AZURE_MAPS_KEY,
          },

          // To disable the map zoom in zoom out
          zoomInteraction: false,
          dblClickZoomInteraction: false,
          dragRotateInteraction: false,
          // interactive: false,
          scrollZoomInteraction: false,
          keyboardInteraction: false
        });

        map.current.events.add("ready", () => {
          dataSourceRef.current.clear();

          setLeafletLocationData([]);

          var dataSource = new atlas.source.DataSource();
          dataSourceRef.current = dataSource;
          map.current.sources.add(dataSource);

          leafletRegionData.current.polygonData.forEach((location) => {
            const polygonFeature = new atlas.data.Feature(
              new atlas.data.Polygon([location.coordinates]),
              { name: location.district, value: location.value, color: location.color }
            );

            dataSource.add(new atlas.Shape(polygonFeature));
          });

          var polygonLayer = new atlas.layer.PolygonLayer(dataSource, 'districtPolygon', {
            fillColor: ["get", "color"],
            fillOpacity: 0.8
          });

          var lineLayer = new atlas.layer.LineLayer(dataSource, 'districtLine', {
            strokeColor: '#001B48',
            strokeWidth: 1
          });

          var hoverLineLayer = new atlas.layer.LineLayer(dataSource, 'hoverLineLayer', {
            strokeColor: '#001B48',
            strokeWidth: 3,
            filter: ['==', ['get', 'name'], ""]
          });

          map.current.layers.add([polygonLayer, lineLayer, hoverLineLayer, new atlas.layer.SymbolLayer(dataSource, null, {
            iconOptions: { opacity: 0 },
            textOptions: {
              textField: ["concat", ["get", "name"], " - ", ["get", "value"]],
              size: 13,
              fontFamily: ["Lato"],
              offset: [0, 0],
              allowOverlap: false,
              ignorePlacement: false,
              textAllowOverlap: false,
            },
            filter: [
              "all",
              ["!", ["has", "cluster"]],
              [">=", ["zoom"], 5]
            ],
          })])

          map.current.events.add("click", polygonLayer, (event) => {
            if (event.shapes.length > 0) {
              setIsOpenDatabar(true);
              isOpenDatabarRef.current = true;
              handleSelectPlace(event.shapes[0].data.properties.name);
              selectedPlaceRef.current = event.shapes[0].data.properties.name;
              hoverLineLayer.setOptions({ filter: ['==', ['get', 'name'], selectedPlaceRef.current] })
            } else {
              isOpenDatabarRef.current = false;
              setIsOpenDatabar(false);
            }
          });

          map.current.events.add('mousemove', polygonLayer, (event) => {
            if (!!isOpenDatabarRef.current) {
              hoverLineLayer.setOptions({ filter: ['==', ['get', 'name'], selectedPlaceRef.current] })
            } else {
              if (!!event.shapes[0].data.properties.name) {
                hoverLineLayer.setOptions({ filter: ['==', ['get', 'name'], event.shapes[0].data.properties.name] })
              } else {
                hoverLineLayer.setOptions({ filter: ['==', ['get', 'name'], ''] })
              }
            }
          });
        });
      }
    } else {
      if (leafletTerritoryData.current) {
        map.current = new atlas.Map(mapRef.current, {
          center: leafletTerritoryData.current.center,
          zoom: leafletTerritoryData.current.zoom,
          showLogo: false,
          style: "road",
          showFeedbackLink: false,
          enableAccessibility: false,
          disableTelemetry: true,
          textAllowOverlap: false,
          authOptions: {
            authType: atlas.AuthenticationType.subscriptionKey,
            subscriptionKey: AZURE_MAPS_KEY,
          },

          // To disable the map zoom in zoom out
          zoomInteraction: true,
          dblClickZoomInteraction: true,
          dragRotateInteraction: true,
          // interactive: false,
          scrollZoomInteraction: true,
          keyboardInteraction: true
        });

        map.current.events.add("ready", async () => {
          dataSourceRef.current.clear();

          var dataSource = new atlas.source.DataSource();
          dataSourceRef.current = dataSource;
          map.current.sources.add(dataSource);

          const geocodeResults = await Promise.all(addresses.map((address) => geocodeAddress(address)));

          const polygonFeature = new atlas.data.Feature(new atlas.data.Polygon([
            [
              [16.6095, 49.1930],
              [16.6128, 49.1930],
              [16.6135, 49.1914],
              [16.6128, 49.1898],
              [16.6095, 49.1898],
              [16.6088, 49.1914],
              [16.6095, 49.1930]
            ]
          ]),
            { name: 'shell' }
          )

          dataSource.add(polygonFeature);

          geocodeResults.filter(Boolean).map(location => {
            const features = new atlas.data.Feature(
              new atlas.data.Point([location.lon, location.lat]), { address: location.address },
            )
            dataSource.add(features);
          });

          var polygonLayer = new atlas.layer.PolygonLayer(dataSource, 'cityPolygon', {
            fillColor: '#B249A5',
            fillOpacity: 0.5
          });

          var lineLayer = new atlas.layer.LineLayer(dataSource, 'cityLine', {
            strokeColor: '#B249A5',
            strokeWidth: 1
          });

          var hoverLineLayer = new atlas.layer.LineLayer(dataSource, 'hoverCityLayer', {
            strokeColor: '#B249A5',
            strokeWidth: 3,
            filter: ['==', ['get', 'name'], ""]
          });

          var bubbleLayer = new atlas.layer.BubbleLayer(dataSource, null, {
            radius: 7,
            color: "gray",
            opacity: 0.8,
            filter: ['==', ['geometry-type'], 'Point']
          });

          map.current.layers.add([polygonLayer, lineLayer, hoverLineLayer, bubbleLayer]);

          map.current.events.add("click", polygonLayer, (event) => {
            if (event.shapes.length > 0) {
              setSelectedInnerTerritory(true);
              isOpenDatabarRef.current = true;
              handleSelectPlace(event.shapes[0].data.properties.name);
              selectedPlaceRef.current = event.shapes[0].data.properties.name;
              hoverLineLayer.setOptions({ filter: ['==', ['get', 'name'], selectedPlaceRef.current] })
            } else {
              isOpenDatabarRef.current = false;
              setSelectedInnerTerritory(false);
            }
          });

          map.current.events.add('mousemove', polygonLayer, (event) => {
            if (!!isOpenDatabarRef.current) {
              hoverLineLayer.setOptions({ filter: ['==', ['get', 'name'], selectedPlaceRef.current] })
            } else {
              if (!!event.shapes[0].data.properties.name) {
                hoverLineLayer.setOptions({ filter: ['==', ['get', 'name'], event.shapes[0].data.properties.name] })
              } else {
                hoverLineLayer.setOptions({ filter: ['==', ['get', 'name'], ''] })
              }
            }
          });

          const popup = new atlas.Popup({
            pixelOffset: [0, 0],
            closeButton: true
          });

          map.current.events.add("click", bubbleLayer, (event) => {
            if (event.shapes.length > 0) {
              const coordinates = event.shapes[0].data.geometry.coordinates;
              if (coordinates) {
                popup.setOptions({
                  position: coordinates,
                  content: `<div style='padding:12px;font-size:13px'><b>${event.shapes[0].data.properties.address}</b></div>`,
                });
                popup.open(map.current);
              }
            }
          });
        });
      }
    }
  }, [
    center,
    locationData,
    setIsOpenDatabar,
    setSelectedPlace,
    setStorePlaceHistory,
    zoom,
    setSelectedInnerTerritory,
    setSelectedTerritory,
    selectedTerritory,
    loadTerritoryMap,
    selectedRegion,
    showFilters
  ]);

  const geocodeAddress = async (address) => {
    try {
      const response = await fetch(
        `https://atlas.microsoft.com/search/address/json?api-version=1.0&subscription-key=${AZURE_MAPS_KEY}&query=${encodeURIComponent(address)}`
      );
      const data = await response.json();

      if (data.results && data.results.length > 0) {
        return { address: address, lat: data.results[0].position.lat, lon: data.results[0].position.lon };
      }
    } catch (error) {
      console.error("Error geocoding address:", error);
    }
    return null;
  };

  const handleSelectPlace = (place) => {
    if (place) {
      const normalized = place.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      const normalizedPlace = normalized.replace(/c/g, "");
      setStorePlaceHistory([breadcrumbData, normalizedPlace]);
      setSelectedPlace(normalizedPlace);
    }
  };

  const closeRegionBar = (isClose) => {
    setIsOpenDatabar(isClose);
    isOpenDatabarRef.current = false;
  }

  const closeIQOSBar = (isClose) => {
    setSelectedInnerTerritory(isClose);
    isOpenDatabarRef.current = false;
  }

  // LOAD PARTICULAR REGION DATA
  const loadRegionData = (regionData) => {

    if (!map.current || !dataSourceRef.current) return;

    if (!regionData) return;

    leafletRegionData.current = regionData;
  }

  // LOAD INNER TERRITORY MAP
  const loadInnerTerritoryMap = (territoryData) => {
    if (!map.current || !dataSourceRef.current) return;

    if (!territoryData) return;

    leafletTerritoryData.current = territoryData;

    setLoadTerritoryMap(true)
  }

  // LOAD INNER TERRITORY DATA
  const loadInnerTerritoryData = (territoryData) => {

    if (!map.current || !dataSourceRef.current) return;

    if (!territoryData) return;

    var dataSource = new atlas.source.DataSource();
    dataSourceRef.current = dataSource;
    map.current.sources.add(dataSource);

    const polygonFeature = new atlas.data.Feature(
      new atlas.data.Polygon([
        [
          [16.6115, 49.1912],
          [16.6241, 49.1920],
          [16.6275, 49.1875],
          [16.6214, 49.1825],
          [16.6115, 49.1912]
        ]
      ]),
      { name: 'shell' }
    );

    dataSource.add(polygonFeature);

    var polygonLayer = new atlas.layer.PolygonLayer(dataSource, 'cityPolygon', {
      fillColor: '#B249A5',
      fillOpacity: 0.5
    });

    var lineLayer = new atlas.layer.LineLayer(dataSource, 'cityLine', {
      strokeColor: '#B249A5',
      strokeWidth: 1
    });

    var hoverLineLayer = new atlas.layer.LineLayer(dataSource, 'hoverCityLayer', {
      strokeColor: '#B249A5',
      strokeWidth: 3,
      filter: ['==', ['get', 'name'], ""]
    });

    map.current.layers.add([polygonLayer, lineLayer, hoverLineLayer]);

    map.current.events.add("click", polygonLayer, (event) => {
      if (event.shapes.length > 0) {
        setSelectedInnerTerritory(true);
        isOpenDatabarRef.current = true;
        handleSelectPlace(event.shapes[0].data.properties.name);
        selectedPlaceRef.current = event.shapes[0].data.properties.name;
        hoverLineLayer.setOptions({ filter: ['==', ['get', 'name'], selectedPlaceRef.current] })
      } else {
        isOpenDatabarRef.current = false;
        setSelectedInnerTerritory(false);
      }
    });

    map.current.events.add('mousemove', polygonLayer, (event) => {
      if (!!isOpenDatabarRef.current) {
        hoverLineLayer.setOptions({ filter: ['==', ['get', 'name'], selectedPlaceRef.current] })
      } else {
        if (!!event.shapes[0].data.properties.name) {
          hoverLineLayer.setOptions({ filter: ['==', ['get', 'name'], event.shapes[0].data.properties.name] })
        } else {
          hoverLineLayer.setOptions({ filter: ['==', ['get', 'name'], ''] })
        }
      }
    });
  }
  //   const handleFullScreenshot = async () => {
  //     setTimeout(async () => {
  //         try {
  //             const element = document.documentElement;
  //             const mapCanvas = document.querySelector(".map-container");
  //             let mapImageUrl = "";

  //             if (mapCanvas) {
  //                 mapImageUrl = mapCanvas.toDataURL("image/png");
  //             }
  //             const canvas = await html2canvas(element, {
  //                 useCORS: true,
  //                 scale: window.devicePixelRatio,
  //                 width: element.scrollWidth,
  //                 height: element.scrollHeight,
  //                 scrollX: -window.scrollX,
  //                 scrollY: -window.scrollY,
  //                 windowWidth: element.scrollWidth,
  //                 windowHeight: element.scrollHeight
  //             });

  //             if (mapImageUrl) {
  //                 const ctx = canvas.getContext("2d");
  //                 const mapImg = new Image();
  //                 mapImg.src = mapImageUrl;
  //                 await new Promise((resolve) => {
  //                     mapImg.onload = () => {
  //                         ctx.drawImage(mapImg, mapCanvas.offsetLeft, mapCanvas.offsetTop);
  //                         resolve();
  //                     };
  //                 });
  //             }
  //             const dataUrl = canvas.toDataURL("image/png");
  //             const link = document.createElement("a");
  //             link.href = dataUrl;
  //             link.download = "fullScreenshot.png";
  //             link.click();
  //         } catch (error) {
  //             console.error("Screenshot failed:", error);
  //         }
  //     }, 500);
  // };
  return (
    <>
      <div className="map-container" ref={mapRef}></div>
      {isOpenDatabar && regionData ? (
        <RegionDataBar isCloseSidebar={closeRegionBar} selectedPlace={selectedPlace} loadRegion={loadRegionData} loadInnerTerritory={loadInnerTerritoryMap}></RegionDataBar>
      ) :
        (<QuickIntro />)
      }
      {!!selectedInnerTerritory && showFilters &&
        <IQOSsidebar isCloseSidebar={closeIQOSBar}></IQOSsidebar>
      }
      {
        showFilters && (
          <div className="d-flex gap-2 filters">
            <Touchpoints changeFilter={loadInnerTerritoryData} />
            <Recommendations />
            <ExternalData />
          </div>
        )
      }

      {/* Change map */}
      {/* <div className="change-map">
        <div role="group" className="flex catchment-btn-wrapper rounded-2 p-1 w-full">
          {["Azure", "Leaflet"].map((option) => (
            <Button key={option} size="small" variant={selectedMap === option ? "black" : "white"}
              className={
                (selectedMap === option
                  ? "active bg-white text-black border rounded-2 py-2"
                  : "border-0 py-0 bg-transparent")
                + " px-3 w-50 text-center"
              }
              onClick={() => { changeMap(option) }}
            >
              {option}
            </Button>
          ))}
        </div>
      </div> */}

      {/* performance progress bar */}
      {selectedIndicator && !showFilters && (
        <div className="shadow-xl p-3 flex flex-col justify-center progress_Container">
          <div className="text-#25282A text-sm fw-bold mb-2">{selectedIndicator}</div>
          <progress width="237px" max="100" value="100">100%</progress>
          <div className="d-flex align-items-center justify-content-between w-100 small">
            <span>HIGH</span>
            <span>LOW</span>
          </div>
        </div>
      )}
    </>
  );
}



